import { render } from "./ResultsSection.vue?vue&type=template&id=f375f1c0&scoped=true"
import script from "./ResultsSection.vue?vue&type=script&lang=js"
export * from "./ResultsSection.vue?vue&type=script&lang=js"

import "./ResultsSection.vue?vue&type=style&index=0&id=f375f1c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f375f1c0"]])

export default __exports__